import { render, staticRenderFns } from "./info-box.vue?vue&type=template&id=632110ee&scoped=true&"
import script from "./info-box.vue?vue&type=script&lang=js&"
export * from "./info-box.vue?vue&type=script&lang=js&"
import style0 from "./info-box.vue?vue&type=style&index=0&id=632110ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632110ee",
  null
  
)

export default component.exports